import React, { useEffect, useRef, useState } from 'react';
import BaseModel from '../../BaseModal';
import {
    FlexWrapperCenter,
    LineView,
    GapView,
    FlexWrapper
} from '../../styles/WrapperStyles';
import { InputText } from '../../styles/TextStyles';
import { BottomButton } from '../../styles/ButtonStyles';
import styled, { css } from 'styled-components';
import urls from '../../api/urls.json';
import { getDateWithTime } from "../../utils";
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import Loader from '../Loader';
import { refundPermission } from '../../access_levels';

const refundReasons = [
    'Auto renewal',
    'Charge back accepted',
    'Deleted account',
    'Repeated payments',
    'Upgrade Issue',
    'Banned',
    'By Mistake',
    'Not Happy',
    'MBG',
    'Test Payment'
];

const OtpInput = styled(InputText)`
  height: 55px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const RefundButton = styled(BottomButton)`
  margin-left: 20px;
  width: 110px;
  height: 55px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #f8f8fa;
  color: #9b9b9b;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
      color: #ffffff;
    `}
`;

const CancelButton = styled(BottomButton)`
    margin-left: 20px;
    width: 110px;
    height: 55px;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #f8f8fa;
    color: #9b9b9b;
    ${props =>
        props.selected &&
        css`
        background-color: #484848;
        color: #ffffff;
    `}
`;

const RefundReasonSelect = styled.select`
  height: 55px;
  min-width: 210px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #d5d9e2;
  background-color: #ffffff;
  color: #484848;
  font-family: 'Gilory-Semi';
  font-size: 16px;
`;

const ParentDiv = styled.div`
  width: 100%;
  margin-left: 1%;
  margin-right: 20px;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
        props.small &&
        css`
      font-size: 16px;
    `}
`;

const ContentDiv = styled.div`
  ${props =>
        props.width &&
        css`
        width=${props.width};
    `}
`;



function InvoicesModal(props) {
    const [refundOrderId, setRefundOrderId] = useState(null);
    const [otp, setOtp] = useState(null);
    const [isPartialRefund, setIsPartialRefund] = useState(null);
    const [paymentGateway, setPaymentGateway] = useState(-1);
    const [refundReason, setRefundReason] = useState('');
    const appName = localStorage.getItem('appName');
    const [isLoading, setIsLoading] = useState(false);
    const accessLevel = localStorage.getItem('accessLevel');
    const partialRefundAlowed = ['subscription', 'non_recurring_subscription', 'recurring_subscription', 'consumable_subscription', 'select_subscription', 'select_non_recurring_subscription', 'plus_recurring', 'plus_non_recurring', 'aisle_plus', 'discounted_aisle_plus', 'concierge_subscription'];

    const openRefundControls = (payment, partialRefund = false) => {
        if (!payment.order_id) {
            alert('Refund is unavailable for this payment because order details are missing');
            return;
        }
        setRefundOrderId(payment.order_id);
        setIsPartialRefund(partialRefund);
        setOtp(null);
        setRefundReason('');
        setPaymentGateway(payment.payment_gateway);
    };

    const issueRefund = async () => {
        if (!otp || !refundReason) {
            alert('Please enter OTP and select a refund reason');
            return;
        }
        var params = {
            order_id: refundOrderId,
            otp: otp,
            is_partial_refund: isPartialRefund,
            payment_gateway: paymentGateway,
            refund_reason: refundReason,
            app_name: appName
        };
        let response = await authorizedHttpPost(urls.REFUND, params);
        if (response.status) {
            props.closeModal();
        }
    };

    const cancelSubscription = async () => {
        var params = {
            ref: props.detailedViewRef,
            app_name: appName
        };
        console.log(params);
        let response = await authorizedHttpPost(urls.CANCEL_SUBSCRIPTION, params);
        if (response.status) {
            props.closeModal();
        }
    };


    return (
        <BaseModel closeModal={props.closeModal}>
            {isLoading && <Loader />}
            <ParentDiv>
                {props.payments.map((payment, pos) => {
                    const isRefundControlsOpen = refundOrderId !== null && refundOrderId === payment.order_id;
                    return (
                        <div key={pos}>
                            <FlexWrapper>
                                <TextView small>
                                    {getDateWithTime(payment.actual_payment_date)}
                                </TextView>
                                <GapView width="15px" />
                                <TextView small>
                                    {getDateWithTime(payment.payment_time)}
                                </TextView>
                                <GapView width="15px" />
                                <ContentDiv width="100px">
                                    <TextView>{payment.payment_type}</TextView>
                                </ContentDiv>
                                <GapView width="15px" />
                                <ContentDiv width="100px">
                                    <TextView>{payment.amount_paid}</TextView>
                                </ContentDiv>
                                <GapView width="15px" />
                                <ContentDiv>
                                    <TextView>{payment.tag}</TextView>
                                </ContentDiv>
                                {refundPermission.includes(accessLevel) ? (
                                    <FlexWrapperCenter>
                                        {!payment.is_refunded ? (
                                            isRefundControlsOpen ? (
                                                <>
                                                    <RefundButton
                                                        selected={isPartialRefund === false}
                                                        onClick={() => {
                                                            setIsPartialRefund(false);
                                                        }}
                                                    >
                                                        {' '}
                                                        Full Refund{' '}
                                                    </RefundButton>
                                                    {!payment.is_refunded &&
                                                        partialRefundAlowed.includes(payment.payment_type) ? (
                                                        <RefundButton
                                                            selected={isPartialRefund === true}
                                                            onClick={() => {
                                                                setIsPartialRefund(true);
                                                            }}
                                                        >
                                                            {' '}
                                                            Partial Refund{' '}
                                                        </RefundButton>
                                                    ) : null}
                                                    <OtpInput
                                                        value={otp || ''}
                                                        onChange={e => {
                                                            setOtp(e.target.value);
                                                        }}
                                                    />
                                                    <RefundReasonSelect
                                                        value={refundReason}
                                                        onChange={e => {
                                                            setRefundReason(e.target.value);
                                                        }}
                                                    >
                                                        <option value="">Select Refund Reason</option>
                                                        {refundReasons.map((reason) => (
                                                            <option key={reason} value={reason}>{reason}</option>
                                                        ))}
                                                    </RefundReasonSelect>
                                                    <RefundButton
                                                        selected={true}
                                                        onClick={() => {
                                                            issueRefund();
                                                        }}
                                                    >
                                                        {' '}
                                                        Refund{' '}
                                                    </RefundButton>
                                                </>
                                            ) : (
                                                <RefundButton
                                                    selected={false}
                                                    onClick={() => {
                                                        openRefundControls(payment);
                                                    }}
                                                >
                                                    {' '}
                                                    Refund{' '}
                                                </RefundButton>
                                            )
                                        ) : null}
                                        {!payment.is_refunded && payment.tag.includes('phonepe') && props.hasActivePhonepeSubscription == true && (
                                        <CancelButton
                                            onClick={() => {
                                                console.log(props.detailedViewRef);
                                                console.log(payment);
                                                cancelSubscription();
                                            }}
                                        >
                                            Cancel {' '}
                                        </CancelButton>
                                    )}
                                    </FlexWrapperCenter>
                                ) : null}
                            </FlexWrapper>
                            <LineView />
                        </div>
                    );
                })}
            </ParentDiv>
        </BaseModel>
    );
}

export default InvoicesModal;
